import { useScrapingZones } from "@/hooks/use-scraping-zones";

/**
 * useNeedsZoneRefine — true tant que l'utilisateur n'a pas affiné sa zone.
 *
 * Signal data-driven (zéro flag, zéro migration) : à la sortie de l'onboarding,
 * les zones ne contiennent que des villes (radius_km = 0 = commune entière).
 * Dès qu'un secteur est ciblé sur la carte (radius_km > 0) puis sauvegardé,
 * le signal repasse à false → la pastille + le message d'affinage disparaissent.
 *
 * Réutilise le cache react-query de useScrapingZones (même clé) → aucune requête
 * supplémentaire.
 */
export function useNeedsZoneRefine(): boolean {
  const { data: zones, isLoading } = useScrapingZones();
  if (isLoading || !zones || zones.length === 0) return false;
  return zones.every((z) => (z.radius_km ?? 0) === 0);
}
